import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, { useMemo } from 'react';
import DropDownFilterChipLayout from 'src/components/10-atoms/filters/DropdownFilterChip';
import FilterSelectChipValue from 'src/components/10-atoms/filters/FilterSelectChipValue';
import { getFilterSelectChipSx, getFilterSelectFormControlSx, getFilterSelectMenuProps, } from 'src/components/10-atoms/filters/filterSelectChipStyles';
import { encodeOptionId, findOptionByEncodedValue, getFilterOptionTitle, } from 'src/components/10-atoms/filters/filterSelectDropdownValue';
import SelectInputDrawer from 'src/components/10-atoms/form/inputs/SelectInput/SelectInputDrawer';
import { ISelectionType } from 'src/components/10-atoms/form/inputs/SelectInput/types';
import Typography from 'src/components/10-atoms/typography/Typography';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import { renderNamedSlot } from 'src/utils/component';
function FilterSelectDropdown({ value, onChange, options, title, selected, LeftIcon, spacing, }) {
    const [{ theme, deviceType }] = useTheme(stylesGenerator);
    const selectedOption = useMemo(() => options.find(option => option.id === value), [options, value]);
    const chipLabel = getFilterOptionTitle(selectedOption?.title)
        || getFilterOptionTitle(options[0]?.title);
    const isSelected = selected ?? selectedOption?.id !== undefined;
    const chipSpacing = spacing ?? theme.spacing.standard.xs;
    const leftIcon = renderNamedSlot(LeftIcon, { size: theme.iconSize.sm });
    const showOptions = useStableCallback(() => {
        bottomDrawerHelperActions.show({
            component: (React.createElement(SelectInputDrawer, { title: title, type: ISelectionType.SINGLE, value: selectedOption, options: options, onChange: option => {
                    bottomDrawerHelperActions.hide();
                    onChange(option.id);
                }, onCancel: bottomDrawerHelperActions.hide })),
        });
    });
    if (deviceType.isPhone) {
        return (React.createElement(DropDownFilterChipLayout, { selected: isSelected, spacing: chipSpacing, onPress: showOptions },
            leftIcon,
            React.createElement(Typography, null, chipLabel)));
    }
    const handleChange = (event) => {
        const option = findOptionByEncodedValue(options, event.target.value);
        onChange(option?.id);
    };
    return (React.createElement(FormControl, { size: "small", sx: getFilterSelectFormControlSx() },
        React.createElement(Select, { value: encodeOptionId(value), onChange: handleChange, displayEmpty: true, variant: "standard", disableUnderline: true, IconComponent: () => null, renderValue: () => (React.createElement(FilterSelectChipValue, { label: chipLabel, leftIcon: leftIcon, spacing: chipSpacing })), MenuProps: getFilterSelectMenuProps(theme), sx: getFilterSelectChipSx(theme, { isSelected }) }, options.map(option => {
            const encoded = encodeOptionId(option.id);
            return (React.createElement(MenuItem, { key: encoded || '__empty__', value: encoded }, getFilterOptionTitle(option.title)));
        }))));
}
const stylesGenerator = createThemedStyle(({}) => ({}));
export default FilterSelectDropdown;
